import React, { useEffect, useRef, useState } from "react";
import styles from './ImageUploader.module.scss';
import PropTypes from "prop-types";

const ImageUploader = ({ initials, image, onChange }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [imageError, setImageError] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setImageUrl(image);
  }, [image]);

  const openUploader = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Extract the file extension (e.g., "jpg", "jpeg", "png")
      const fileExtension = file.name.split('.').pop().toLowerCase();
      // Check if the file extension is valid
      if (!['jpg', 'jpeg', 'png'].includes(fileExtension)) {
        setImageError("Please select a valid image file");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImageUrl(reader.result);
        setImageError(null);
        onChange(file);
      };
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.round} ${!imageUrl ? styles.warning : ''}`}
        onClick={openUploader}
      >
        { imageUrl ? (
          <img
            src={imageUrl}
            alt="Profile"
          />
        ) : <span>{initials}</span> }
      </div>
      <div className={styles.edit}>
        <input
          type="file"
          accept=".jpg, .jpeg, .png"
          ref={fileInputRef}
          onChange={handleImageChange}
        />
        <button
          type="button"
          onClick={openUploader}
        >
          Edit
        </button>
        <span>JPG,JPEG or PNG.</span>
        {imageError && <span className={styles.error}>{imageError}</span>}
      </div>
    </div>
  );
};

ImageUploader.propTypes = {
  initials: PropTypes.string.isRequired,
  image: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default ImageUploader;